import * as React from 'react';
import { Body2 } from '@cian/ui-kit';

import { IRoomStatsCell } from '../../../../../../types/newbuildingsCompare';

export interface IRoomStatsCellProps {
  cell: IRoomStatsCell;
}

export const RoomStatsCell = ({ cell }: IRoomStatsCellProps): React.JSX.Element => (
  <Body2>{cell.data?.roomLink.text ?? cell.state.text ?? ''}</Body2>
);
